<template>
    <PanelListing />
</template>
<script>
import PanelListing from '@/views/pages/public/panel/panelListing'
import i18n from "@/i18n";

export default {
    page: {
        title: i18n.t("module.panel"),
    },
    components: { PanelListing },
    data() {
        return {

        };
    },
}
</script>
